import { render, staticRenderFns } from "./updateMailStatus.vue?vue&type=template&id=3f5343e5&scoped=true&"
import script from "./updateMailStatus.vue?vue&type=script&lang=js&"
export * from "./updateMailStatus.vue?vue&type=script&lang=js&"
import style0 from "./updateMailStatus.vue?vue&type=style&index=0&id=3f5343e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5343e5",
  null
  
)

export default component.exports